<ng-container *transloco="let t; prefix: 'PremiseHazardType'">
  <form [formGroup]="PremiseHazardTypeForm" (ngSubmit)="onSubmit()" [disabled]="IsSubmitting" class="edit-container">
    <div class="edit-container-header">
      <button type="button" pButton (click)="cancelClicked()"><msi-icon name="ic_back" /></button>
      <ng-container [ngTemplateOutlet]="formButtons" [ngTemplateOutletContext]="{ form: PremiseHazardTypeForm }"></ng-container>
    </div>
    <div class="edit-container-body">
      <label class="msi-label msi-margin-bottom-s">{{ PageTitle }}</label>

      <ng-container [ngTemplateOutlet]="codeForm" [ngTemplateOutletContext]="{ form: PremiseHazardTypeForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="descriptionForm" [ngTemplateOutletContext]="{ form: PremiseHazardTypeForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="proximitiesForm" [ngTemplateOutletContext]="{ form: PremiseHazardTypeForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="orderForm" [ngTemplateOutletContext]="{ form: PremiseHazardTypeForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="cadCloudConfigForm" [ngTemplateOutletContext]="{ form: PremiseHazardTypeForm }"></ng-container>
    </div>
  </form>

  <ng-template #codeForm let-form="form">
    <div [formGroup]="form" class="edit-form-input-container">
      <div class="edit-form-label-row">
        <label class="msi-label">{{ t('label.code') }}</label>
        @if (!form.controls.code.valid) {
          <msi-icon name="ic_error" class="error_icon" [pTooltip]="'General.fieldIsRequired' | transloco" />
        }
      </div>
      <input pInputText class="msi-margin-s" placeholder="{{ t('placeholder.code')}}" formControlName="code" />
    </div>
  </ng-template>

  <ng-template #descriptionForm let-form="form">
    <label class="msi-label">{{ t('label.description') }}</label>
    <div [formGroup]="form" class="input-container">
      <textarea pTextarea class="msi-margin-s full-width-input" placeholder="{{ t('placeholder.description') }}" formControlName="description"></textarea>
    </div>
  </ng-template>

  <ng-template #proximitiesForm let-form="form">
    <label class="msi-label"><msi-icon name="ic_help" [pTooltip]="t('tooltip.roundingWarning')" />{{ t('Item.section.proximities') }}</label>
    {{ t('Item.text.proximities', { currentUnits: CurrentUnitsText}) }}
    <div class="flex-container-row">
      <ng-container [ngTemplateOutlet]="directHitDistanceForm" [ngTemplateOutletContext]="{ form: form }"></ng-container>
      <ng-container [ngTemplateOutlet]="innerProximityForm" [ngTemplateOutletContext]="{ form: form }"></ng-container>
      <ng-container [ngTemplateOutlet]="outerProximityDistance" [ngTemplateOutletContext]="{ form: form }"></ng-container>
    </div>
  </ng-template>

  <ng-template #directHitDistanceForm let-form="form">
    <div [formGroup]="form" class="edit-form-input-container-no-grow">
      <div class="edit-form-label-row">
        <label class="msi-label">{{ t('label.directHitDistance') }}</label>
        @if (!form.controls.directHitDistance.valid) {
          <msi-icon name="ic_error" class="error_icon" [pTooltip]="t('error.directHitDistance', {minimum: MinimumDistance, currentUnits: CurrentUnitsText })"></msi-icon>
        }
      </div>
      <div class="input-container-no-grow">
        <input pInputText class="msi-margin-s" formControlName="directHitDistance" type="number" [placeholder]="MinimumDistance" />
      </div>
    </div>
  </ng-template>

  <ng-template #innerProximityForm let-form="form">
    <div [formGroup]="form" class="edit-form-input-container-no-grow msi-margin-left-m">
      <div class="edit-form-label-row">
        <label class="msi-label">{{ t('label.innerProximityDistance') }}</label>
        @if (!form.controls.innerProximityDistance.valid) {
          <msi-icon name="ic_error" class="error_icon" [pTooltip]="t('error.innerProximityDistance')"></msi-icon>
        }
      </div>
      <div class="input-container-no-grow">
        <input pInputText class="msi-margin-s" formControlName="innerProximityDistance" type="number" />
      </div>
    </div>
  </ng-template>

  <ng-template #outerProximityDistance let-form="form">
    <div [formGroup]="form" class="edit-form-input-container-no-grow msi-margin-left-m">
      <div class="edit-form-label-row">
        <label class="msi-label">{{ t('label.outerProximityDistance') }}</label>
        @if (!form.controls.outerProximityDistance.valid) {
          <msi-icon name="ic_error" class="error_icon" [pTooltip]="t('error.outerProximityDistance')"></msi-icon>
        }
      </div>
      <div class="input-container-no-grow">
        <input pInputText class="msi-margin-s" formControlName="outerProximityDistance" type="number" />
      </div>
    </div>
  </ng-template>

  <ng-template #orderForm let-form="form">
    <div [formGroup]="form" class="form-row">
      <div class="edit-form-input-container-no-grow">
        <label class="msi-label">{{ t('label.displayOrder') }}</label>
        <input pInputText class="msi-margin-s" placeholder="{{ t('placeholder.displayOrder') }}" formControlName="displayOrder" type="number" />
      </div>

      <div class="edit-form-input-container-no-grow msi-margin-left-m">
        <label class="msi-label">{{ t('label.tearAndRunOrder') }}</label>
        <input pInputText class="msi-margin-s" placeholder="{{ t('placeholder.tearAndRunOrder') }}" formControlName="tearAndRunOrder" type="number" />
      </div>
    </div>
  </ng-template>

  <ng-template #cadCloudConfigForm let-form="form">
    <div [formGroup]="form">
      <label class="msi-label">
        {{ t('Item.section.cadCloudConfig') }}
      </label>
      <div class="flex-container-row">
        <ng-container [ngTemplateOutlet]="cadCloudDirectHitForm" [ngTemplateOutletContext]="{ form: form }"></ng-container>
        <ng-container [ngTemplateOutlet]="cadCloudInnerProximityForm" [ngTemplateOutletContext]="{ form: form }"></ng-container>
        <ng-container [ngTemplateOutlet]="cadCloudOuterProximityForm" [ngTemplateOutletContext]="{ form: form }"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #cadCloudDirectHitForm let-form="form">
    <div [formGroup]="form" class="edit-form-input-container">
      {{ t('label.directHit') }}
      <div class="msi-checkbox-group">
        <div class="msi-checkbox-row"><p-checkbox [binary]="true" inputId="directHitVisual" formControlName="directHitVisual" /><label for="directHitVisual">{{ t('label.visual') }}</label></div>
        <div class="msi-checkbox-row"><p-checkbox [binary]="true" inputId="directHitAudio" formControlName="directHitAudio" /><label for="directHitAudio">{{ t('label.audible') }}</label></div>
      </div>
    </div>
  </ng-template>

  <ng-template #cadCloudInnerProximityForm let-form="form">
    <div [formGroup]="form" class="edit-form-input-container">
      {{ t('label.innerProximity') }}
      <div class="msi-checkbox-group">
        <div class="msi-checkbox-row"><p-checkbox [binary]="true" inputId="innerProximityVisual" formControlName="innerProximityVisual" /><label for="innerProximityVisual">{{ t('label.visual') }}</label></div>
        <div class="msi-checkbox-row"><p-checkbox [binary]="true" inputId="innerProximityAudio" formControlName="innerProximityAudio" /><label for="innerProximityAudio">{{ t('label.audible') }}</label></div>
      </div>
    </div>
  </ng-template>

  <ng-template #cadCloudOuterProximityForm let-form="form">
    <div [formGroup]="form" class="edit-form-input-container">
      {{ t('label.outerProximity') }}
      <div class="msi-checkbox-group">
        <div class="msi-checkbox-row"><p-checkbox [binary]="true" inputId="outerProximityVisual" formControlName="outerProximityVisual" /><label for="outerProximityVisual">{{ t('label.visual') }}</label></div>
        <div class="msi-checkbox-row"><p-checkbox [binary]="true" inputId="outerProximityAudio" formControlName="outerProximityAudio" /><label for="outerProximityAudio">{{ t('label.audible') }}</label></div>
      </div>
    </div>
  </ng-template>

  <ng-template #formButtons let-form="form">
    <div [formGroup]="form" class="edit-toolbar-right">
      <button type="button" pButton (click)="cancelClicked()" [disabled]="IsSubmitting">
        <msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.cancel' | transloco }}
      </button>
      <button pButton type="submit" [disabled]="IsSubmitting || !form.valid">
        @if (IsSubmitting) {
          <p-progress-spinner class="justify-content-center" />
        }<msi-icon name="ic_add" />{{ 'Buttons.save' | transloco }}
      </button>
    </div>
  </ng-template>
  </ng-container>
